import CreateCategoryContainer from "@containers/dashboard/categories/create";
import DashboardLayout from "@layouts/dashboard";

const CreateCategory = () => {
    return (
        <DashboardLayout title="دسته بندی جدید">
            <CreateCategoryContainer />
        </DashboardLayout>
    );
};

export default CreateCategory;
